import React, { useEffect, useState, useContext } from 'react';
import { List, Progress, Statistic, Steps, Button, message, Badge, Drawer, Descriptions } from 'antd';
import { getExamQuestions, getStudentExams, setStartExam, getQuestionByIdWithOutAnswer, setQuestionAnswer } from '../../actions';
import { FormOutlined, PlayCircleOutlined } from '@ant-design/icons';
import { Context } from '../../defaults';
import Question from './question';
import moment from 'moment';
import './index.css';

const { Step } = Steps;
const { Countdown } = Statistic;



function PassExam() {
  const { dictionary, language, loading, setLoading } = useContext(Context);
  const [studentExams, setStudentExams] = useState([]);
  const [startedExam, setStartedExam] = useState(() => {
    if (sessionStorage['exam']) {
      const exam = JSON.parse(sessionStorage['exam']);
      const endTime = moment(exam.endTime, 'HH:mm:ss');
      const endDateTime = moment(exam.endDate).add(endTime.hour(), 'hours').add(endTime.minute(), 'minutes');
      if (endDateTime < moment()) {
        sessionStorage.clear();
        setCurrent(0);
        setExamQuestions({});
        setExamAnswers([]);
        setQuestion({});
      }
      return exam;
    }
    return {};
  });

  const [current, setCurrent] = useState(0);
  const [showStartExam, setShowStartExam] = useState({});
  const [examQuestions, setExamQuestions] = useState({});
  const [isAnswered, setIsAnswered] = useState(true);
  const [examAnswers, setExamAnswers] = useState([]);
  const [question, setQuestion] = useState({});

  const next = () => {
    if (examQuestions && examQuestions.questionIds) {
      setLoading(true);
      setQuestionAnswer(examQuestions.id, examQuestions.questionIds[current], question.usedHint, question).then(res => {
        setLoading(false);
        setIsAnswered(true);
        console.log('res', res);
      });
    }
    setCurrent(current + 1);
  };

  const done = (item) => {

    if (examQuestions && examQuestions.questionIds) {
      setLoading(true);

      setQuestionAnswer(examQuestions.id, examQuestions.questionIds[current], question.usedHint, question).then(res => {
        setStartExam({ ...examQuestions, status: 2 }).then(res => {
          setLoading(false);
          setIsAnswered(true);
          message.success(dictionary?.OperationSuccessful[language]);
          sessionStorage.clear();
          setStartedExam({});
          setCurrent(0);
          setExamQuestions({});
          setExamAnswers([]);
          setQuestion({});
        });
      });
    }
    else if (item) {
      setLoading(true);
      getExamQuestions(item.id)
        .then(({ data }) => {
          setLoading(false);
          setStartExam({ ...data, status: 2 }).then(res => {
            message.success(dictionary?.OperationSuccessful[language]);
            sessionStorage.clear();
            setStartedExam({});
            setCurrent(0);
            setExamQuestions({});
            setExamAnswers([]);
            setQuestion({});
          });

        });

    }
  }

  const prev = () => {
    if (examQuestions && examQuestions.questionIds) {
      setLoading(true);
      setQuestionAnswer(examQuestions.id, examQuestions.questionIds[current], question.usedHint, question).then(res => {
        setLoading(false);
        setIsAnswered(true);
        console.log('res', res);
      });
    }
    setCurrent(current - 1);
  };

  useEffect(() => {
    if (isAnswered) {
      if (examQuestions && examQuestions.questionIds) {
        setLoading(true);
        getQuestionByIdWithOutAnswer(examQuestions.questionIds[current], examQuestions.id).then(res => {
          setLoading(false);
          setQuestion(res.data);
          setIsAnswered(false);
        });
      }
    }
  }, [examQuestions, current, isAnswered]);

  useEffect(() => {
    getStudentExams()
      .then(({ data }) => {
        setStudentExams(data);
        if (startedExam && startedExam.id) {
          const filtered = data.filter(x => x.id === startedExam.id);
          if (filtered.length > 0) {
            onClickGetExamQuestions(filtered[0]);
          }
        }
      });
  }, []);

  const setIndex = (index) => {
    setCurrent(index);
    setLoading(true);
    if (examQuestions && examQuestions.questionIds) {
      setLoading(true);
      setQuestionAnswer(examQuestions.id, examQuestions.questionIds[current], question.usedHint, question).then(res => {
        setLoading(false);
        setIsAnswered(true);

        console.log('res', res);
      });
    }
  }


  const onClickGetExamQuestions = (element) => {
    // const endTime = moment(exam.endTime, 'HH:mm:ss');
    // const endDateTime = moment(exam.endDate).add(endTime.hour(), 'hours').add(endTime.minute(), 'minutes');
    // return moment(exam.factStartedTime) + parseInt(exam.examDuration) * 60 * 1000 - endDateTime;

    // console.log('element', element);

    setLoading(true);


    getExamQuestions(element.id)
      .then(({ data }) => {
        setLoading(false);

        const questLength = [];
        for (let i = 0; i < data.questionIds.length; i++) {
          questLength.push(null);
        }
        setExamAnswers([...questLength]);

        if (data.status < 2) {
          setStartExam({ ...data, status: 1 }).then(res => {
            setExamQuestions(data || {});
          });
          if (!startedExam.factStartedTime) {
            setStartedExam({ ...element, factStartedTime: Date.now() });
            sessionStorage.setItem('exam', JSON.stringify({ ...element, factStartedTime: Date.now() }));
          }
        }
        else {
          message.error(dictionary?.ProcessingComplete[language], 4);
        }
      });

  }

  const onFinish = (name) => {
    setShowStartExam({ ...showStartExam, [name]: true });
  }

  const getStep = (start, end) => {
    const now = Date.now();
    if (now > start && now < end) {
      return 1;
    }
    else if (now < start) {
      return -1;
    }
    else if (now > end) {
      return 2;
    }
  }

  const delta = (exam) => {

    const endTime = moment(exam.endTime, 'HH:mm:ss');
    const endDateTime = moment(exam.endDate).add(endTime.hour(), 'hours').add(endTime.minute(), 'minutes');
    return moment(exam.factStartedTime) + parseInt(exam.examDuration) * 60 * 1000 - endDateTime;
  }


  return (
    <React.Fragment>
      <List
        itemLayout='vertical'
        size='default'
        pagination={{
          pageSize: 20,
        }}
        dataSource={studentExams}
        renderItem={(item, index) => {
          const time = moment(item.startTime, 'HH:mm:ss');
          const endTime = moment(item.endTime, 'HH:mm:ss');
          const startDateTime = moment(item.examDate).add(time.hour(), 'hours').add(time.minute(), 'minutes');
          const endDateTime = moment(item.endDate).add(endTime.hour(), 'hours').add(endTime.minute(), 'minutes');
          const examStatus = startedExam.id === item.id;
          return (
            <List.Item
              key={item.name}
              extra={
                ((showStartExam[item.name] || (Date.now() > startDateTime && Date.now() < endDateTime))) ?
                  <div>
                    <Button size='large' type='dashed' shape={'round'}
                      disabled={examStatus}
                      onClick={() => {
                        if (!startedExam.id) {
                          if (item.status === 3) {
                            onClickGetExamQuestions(item);
                          }
                          else {
                            message.error(dictionary?.DoesNotHasVariants[language], 4);
                          }
                        }
                        else {
                          message.error(dictionary?.HaveActualExam[language], 4);
                        }
                      }}
                      icon={examStatus ? <FormOutlined /> : <PlayCircleOutlined />}
                      style={{ marginTop: 30 }}
                    >
                      {examStatus ? dictionary?.Started[language] : dictionary?.Start[language]}
                    </Button>
                    <Countdown
                      title={dictionary?.ToEndExam[language]}
                      value={moment(endDateTime, 'seconds')}
                      format={`D ${dictionary?.Days[language]} mm:ss`}
                      onFinish={() => done(item)}
                    />
                  </div>
                  :
                  (
                    (getStep(startDateTime, endDateTime) === 2 || item.finished === 1) ?
                      <Progress style={{ marginTop: 24 }} type='circle' percent={100} width={50} status={item.finished === 1 ? 'success' : 'exception'} /> :
                      <Countdown
                        style={{ marginTop: 20 }}
                        title={dictionary?.ToStartExam[language]}
                        value={Date.now() + moment().add(-1 * (time.hour() * 60 * 60 + time.minute() * 60), 'seconds').diff(item.examDate, 'seconds') * (-1000)}
                        onFinish={() => onFinish(item.name)}
                        format={`D ${dictionary?.Days[language]} HH:mm:ss`} />
                  )
              }
            >
              <List.Item.Meta
                title={item.name}
                description={
                  <Steps current={getStep(startDateTime, endDateTime)}>
                    <Step title={dictionary?.StartDate[language]} description={`${moment(item.examDate).format('DD.MM.YYYY')} ${item.startTime}`} />
                    <Step title={dictionary?.Duration[language]} description={`${item.examDuration} мин`} />
                    <Step title={dictionary?.EndDate[language]} description={`${moment(item.endDate).format('DD.MM.YYYY')} ${item.endTime}`} />
                  </Steps>
                }
              />
            </List.Item>
          )
        }
        }
      />
      {
        startedExam.id &&
        <React.Fragment>
          <Descriptions style={{ marginTop: 24 }} column={6} bordered>
            <Descriptions.Item span={6} label={dictionary?.ToEndExam[language]}>
              <Countdown
                value={
                  (startedExam.factStartedTime ?
                    parseInt(startedExam.factStartedTime) : Date.now())
                  + parseInt(startedExam.examDuration) * 60 * 1000
                  - Math.max(delta(startedExam), 0)
                  // -(endDateTime-startDateTime===startedExam.examDuration)
                }
                format={`mm:ss ${dictionary?.Left[language]}`}
                onFinish={done}
              />
            </Descriptions.Item>
            <Descriptions.Item span={3} label={dictionary?.Subject[language]}>{startedExam.subjectName}</Descriptions.Item>
            <Descriptions.Item span={3} label={dictionary?.VariantNumber[language]}>{examQuestions.variantNumber}</Descriptions.Item>

          </Descriptions>

          <Steps current={current} style={{ marginTop: 24 }} size='small'>
            {
              examQuestions.questionIds &&
              examQuestions.questionIds.map((_, index) => {
                return <Step key={`question${index}`} style={{ cursor: 'pointer' }} onClick={() => setIndex(index)} />;
              })
            }
          </Steps>

          <Badge.Ribbon text={`${dictionary?.QuestionLevel[language]} - ${question.questionLevel}`}>
            <div className='steps-content'>
              <div className='site-drawer-render-in-current-wrapper'>
                {
                  !loading && question.questionTypeId &&
                  <Question data={question} setData={setQuestion} examAnswers={examAnswers} setExamAnswers={setExamAnswers} current={current} />
                }
                {
                  question.hasHint === 1 &&
                  <Drawer
                    width={500}
                    placement='right'
                    closable={false}
                    onClose={() => setQuestion({ ...question, showHint: false })}
                    visible={question.showHint}
                    getContainer={false}
                    style={{ position: 'absolute' }}
                  >
                    {
                      question.hintText &&
                      <p>{question.hintText}</p>
                    }
                    {
                      question.hintHtml &&
                      <p style={{ wordWrap: 'break-word' }} dangerouslySetInnerHTML={{ __html: question.hintHtml }} />
                    }
                  </Drawer>
                }
              </div>
            </div>
          </Badge.Ribbon>

          <div className='steps-action'>
            {
              current < examQuestions?.questionIds?.length - 1 && (
                <Button type='primary' onClick={() => next()}>
                  {dictionary?.Next[language]}
                </Button>
              )
            }
            {
              current === examQuestions?.questionIds?.length - 1 && (
                <Button type='primary' onClick={() => done()}>
                  {dictionary?.Done[language]}
                </Button>
              )
            }
            {
              current > 0 && (
                <Button style={{ margin: '0 8px' }} onClick={() => prev()}>
                  {dictionary?.Previous[language]}
                </Button>
              )
            }
            {
              question.hasHint === 1 &&
              <Button style={{ margin: '0 8px' }} onClick={() => setQuestion({ ...question, showHint: true, usedHint: 1 })}>
                {dictionary?.Hint[language]}
              </Button>
            }
          </div>
        </React.Fragment>
      }

    </React.Fragment>
  );
}

export default PassExam;
